export default "/assets/images/mila-feed-06-thumbnail.2550439da8adf6ce.jpg";